import Dropzone from "react-dropzone";
import React from "react";
import './upload.scss';
import icon from '~/assets/icons/upload.svg';
import { connect } from 'react-redux';
import TextTranslate, { TextTranslateString } from '../TextTranslate/TextTranslate';

const Upload = ({
    sendFiles,
    maxFiles = 0,
    accept = 'jpg, png, pdf',
    acceptMimes = 'image/*,application/pdf,application/x-pdf',
    ...props
}) => {

    return (

        <div className="uploader">

            <Dropzone
                accept={acceptMimes}
                maxFiles={maxFiles}
                minSize={0}
                onDrop={x => sendFiles(x)}
            >
                {({
                    getRootProps,
                    getInputProps,
                    isDragActive,
                    isDragReject,
                    fileRejections
                }) => {

                    const fileRejectionItems = fileRejections.map(({ file, errors }) => (
                        <li key={file.path}>
                            {file.path} - {file.size} bytes
                            <ul>
                                {errors.map(e => (
                                    <li key={e.code}>{e.message}</li>
                                ))}
                            </ul>
                        </li>
                    ));

                    const rejected = isDragReject || fileRejectionItems.length > 0;

                    const Message = () => {

                        if (isDragReject) {
                            return <span className="text-danger">File type not accepted, sorry!</span>;
                        }

                        if (isDragActive) {
                            return <span>Drop it like it's hot!</span>;
                        }

                        return <TextTranslate name="docs-browse-your-files" fallback="Or you can <u>browse</u> your files"/>
                    };

                    return (
                        <div {...getRootProps()} className="fileupload">
                            <div className="upload-icon">
                                <img src={icon} alt="upload" />
                            </div>
                            <h4 className="upload-title">
                                {props.content === 'host' ?
                                    TextTranslateString("docs-upload-guest", 'Upload you guest', props.currentLanguage, props.translations) :
                                    TextTranslateString("docs-drag-drop", 'Drag & Drop', props.currentLanguage, props.translations)
                                }
                            </h4>
                            <div className="form-group">
                                <div className="dropZone">
                                    <input {...getInputProps()} name={props.name} />
                                    <Message />
                                </div>
                            </div>
                        </div>
                    );
                }}
            </Dropzone>

            {props.content === 'host' ? null : <small><TextTranslate name="docs-accepted-formats" fallback="Accepted Formats:" textOnly/> {accept}</small>}
        </div>
    );
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
    translations: state.translations?.translations,
});

export default connect(mapStateToProps)(Upload);
